export class Platform {
  public id: number;

  public accountId: string;

  public code: string;
  public authorizationUrl: string;
  public name: string;
}
